//@author: mandy

import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { S25BreakpointComponent } from "./s25.breakpoint.component";

import { S25IconComponent } from "../s25-icon/s25.icon.component";

import { S25IconButtonComponent } from "../../standalone/s25.icon.button.component";

@NgModule({
    declarations: [S25BreakpointComponent],
    imports: [CommonModule, FormsModule, S25IconComponent, S25IconButtonComponent],
    providers: [S25BreakpointComponent],
    exports: [S25BreakpointComponent],
})
export class S25BreakpointModule {
    constructor() {}
}
